
export interface Session {
	token: string,
	usuario: Usuario,
	otherSystemData: OtherSystemData
}

export interface Usuario {
	nombre: string,
	apellido: string,
	fechaNac: string,
	foto: string,
	tipoDoc: string,
	nroDoc: number,
	isExterno: boolean,
	expiracionClave: UsuarioExpiracionClave
}

export interface OtherSystemData {
	idPersonaInstitucional: number,
	idPersona?: number,
	idPersonaFederada?: number,
	idUsuario?: number,
	nombreUsuario?: string,
	phpSession?: string,
	usuarioEncriptado?: string,
	ce?: string,
	session?: string
}

export interface TokenInfo {
	ipi: string,
	ps: string,
	ce: string,
	se: string
}

export interface UsuarioAcceso {
	tokenAcceso: string
}

export interface  UsuarioDarAvisoExpiracionClave {
	darAviso: boolean
}

export enum UsuarioExpiracionClaveSeverity {
	NORMAL, WARN, CHANGE
}

export interface UsuarioExpiracionClave extends UsuarioDarAvisoExpiracionClave {
	dias: number,
	puedePosponer: boolean,
	fechaExpiracionAsDesc: string
	severity: string
}

export const SEVERITY_COLOR: { [severity: string]: string } = {};
SEVERITY_COLOR[ UsuarioExpiracionClaveSeverity.NORMAL ] = "#212529";
SEVERITY_COLOR[ UsuarioExpiracionClaveSeverity.WARN ] = "#CA6510";
SEVERITY_COLOR[ UsuarioExpiracionClaveSeverity.CHANGE ] = "#D32F2F";

export const INTRANET_TOKEN_KEY: string = 'itkn';
export const INTRANET_REQUESTED_URL_LABEL: string = 'irurl';
export const DEFAULT_INITIAL_URL: string = '';

